import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/historico-vacaciones';

/**
 * GET Historicos Vacaciones Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getHistoricoVacacionesEmpleados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Historico Vacacion Empleado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getHistoricoVacacionEmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Historico Vacacion Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postHistoricoVacacionEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Historico Vacacion Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchHistoricoVacacionEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Historico Vacacion Empleado
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteHistoricoVacacionEmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};
